import { PropertyPageCtaToggle } from '../../../graphql/fragments/propertyPageCtaToggleFragment';
import { isNotNullOrUndefinedValue } from '../../../../helpers/isNotNullOrUndefinedValue';
import { PropertyPageCtaButton } from '../../../graphql/fragments/propertyPageCtaButtonFragment';
import { PropertyPageCtaLink } from '../../../graphql/fragments/propertyPageCtaLinkFragment';
import { mapApiWeblinkVariantToLinkVariant } from '../../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapIconName } from '../../../../app-kit/helpers/mapIconName';
import { mapLinkIconPlacement } from '../../../../app-kit/helpers/mapLinkIconPlacement';
import { mapButtonVariant } from '../../../../app-kit/helpers/mapButtonVariant';
import {
  CtaButtonViewProps,
  CtaLinkViewProps,
  CtaList,
  CtaToggleViewProps,
  CtaType,
} from '../HeaderCtasV2';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';

type PropertyPageHeaderCta = PropertyPageCtaToggle | PropertyPageCtaButton | PropertyPageCtaLink;

const mapToCtaToggleViewProps = (cta: PropertyPageCtaToggle): CtaToggleViewProps => ({
  ...cta,
  type: CtaType.toggle,
  activeItemIndex: cta.activeItemIndex,
  items: cta.items.map((toggleTab) => ({
    ...toggleTab,
    iconInfo: null,
    callout: null,
    variant: mapApiWeblinkVariantToLinkVariant(toggleTab.variant),
  })),
});

const mapToCtaButtonViewProps = (cta: PropertyPageCtaButton): CtaButtonViewProps => ({
  ...cta,
  type: CtaType.button,
  icon: mapIconName(cta.iconName),
  iconPlacement: mapLinkIconPlacement(cta.iconPlacement),
  sizeVariant: cta.sizeVariant ?? undefined,
  variant: mapButtonVariant(cta.buttonVariant),
  text: cta.text,
  ctaVariant: cta.ctaVariant,
});

const mapToCtaLinkViewProps = (cta: PropertyPageCtaLink): CtaLinkViewProps => ({
  ...cta.webLink,
  type: CtaType.link,
  variant: mapApiWeblinkVariantToLinkVariant(cta.webLink.variant),
  iconInfo: cta.webLink.iconInfo ? mapApiWeblinkIconInfoToLinkIconInfo(cta.webLink.iconInfo) : null,
  callout: null,
  isFeatured: cta.isFeatured,
});

export const mapHeaderCtasV2 = (ctas: PropertyPageHeaderCta[]): CtaList =>
  ctas
    .map((cta) => {
      if (cta.__typename === 'PropertyPage_CtaToggle') return mapToCtaToggleViewProps(cta);
      if (cta.__typename === 'PropertyPage_CtaButton') return mapToCtaButtonViewProps(cta);
      if (cta.__typename === 'PropertyPage_CtaLink') return mapToCtaLinkViewProps(cta);

      return null;
    })
    .filter(isNotNullOrUndefinedValue);
